// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropdownProductFeatures {
    border: solid 1px #DCE2F0;
    margin-bottom: 32px;
    border-radius: 8px;
    overflow: hidden;
}

.DropdownProductFeatures-header {
    padding: 24px 0;
    width: 100%;
    max-width: 100vw;
    display: grid;
    align-items: center;
    justify-content: center;
    grid-template-columns: 1fr;
}

.DropdownProductFeatures-title {
    font-size: var(--titleShowcaseStoresTitleSize);
    color: var(--titleShowcaseStoresTitleColor);
    font-weight: bold;
    font-family: var(--font-family);
}

.DropdownProductFeatures .ant-collapse-header,
.DropdownProductFeatures .ant-collapse-content{
    position: relative;
}

.DropdownProductFeatures > .ant-collapse > .ant-collapse-item:not(:last-child) .ant-collapse-header:after,
.DropdownProductFeatures > .ant-collapse > .ant-collapse-item:not(:last-child) .ant-collapse-content:after,
.DropdownProductFeatures > .ant-collapse > .ant-collapse-item:last-child .ant-collapse-content:before {
    content: '';
    display: block;
    width: calc(100% - 64px);
    height: 2px;
    background: #DCE2F0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0 auto;
}

.DropdownProductFeatures > .ant-collapse:last-child .ant-collapse-content:before {
    bottom: initial;
    top: 0;
}

.DropdownProductFeatures .CollapseIconCustom-arrow {
    font-size: calc(var(--storeNameSize) + 6px)  !important;
    line-height: calc(var(--storeNameSize) + 12px) !important;
    position: absolute;
    right: 32px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    color: var(--titleShowcaseStoresLinkColor) !important;
    transition: ease 200ms all;
}

.DropdownProductFeatures .CollapseIconCustom-arrow.active {
    transform: rotateZ(-180deg);
}

.DropdownProductFeatures .DropdownProductFeatures-title {
    display: block;
    padding: 16px 0;
    font-family: var(--font-family);
    color: var(--storeNameColor);
    font-weight: bold;
    font-size: var(--storeNameSize);
    line-height: calc(var(--storeNameSize) + 6px);
}


.DropdownProductFeatures .ant-collapse-content {
    padding: 18px 32px 24px;
}

.DropdownProductFeatures > .ant-collapse:last-child .ant-collapse-content {
    margin-bottom: 24px;
}

.DropdownProductFeatures .ant-collapse-content .ant-collapse-content-box {
    padding: 0;
}

.DropdownProductFeatures .ant-collapse-content,
.DropdownProductFeatures .ant-collapse-header{
    background-color: #ffffff !important;
}


.DropdownProductFeatures-text {
    font-family: var(--font-family);
    font-size: var(--storeNameSize);
    line-height: calc(var(--storeNameSize) + 6px);
    word-spacing: 2px;
}

.DropdownProductFeatures-text strong,
.DropdownProductFeatures-text b {
    font-weight: bold;
    display: inline;
    padding-right: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/DropdownProductFeatures/style.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,8CAA8C;IAC9C,2CAA2C;IAC3C,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;;IAGI,WAAW;IACX,cAAc;IACd,wBAAwB;IACxB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,MAAM;AACV;;AAEA;IACI,uDAAuD;IACvD,yDAAyD;IACzD,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,cAAc;IACd,qDAAqD;IACrD,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,+BAA+B;IAC/B,4BAA4B;IAC5B,iBAAiB;IACjB,+BAA+B;IAC/B,6CAA6C;AACjD;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,oCAAoC;AACxC;;;AAGA;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,6CAA6C;IAC7C,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB","sourcesContent":[".DropdownProductFeatures {\n    border: solid 1px #DCE2F0;\n    margin-bottom: 32px;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.DropdownProductFeatures-header {\n    padding: 24px 0;\n    width: 100%;\n    max-width: 100vw;\n    display: grid;\n    align-items: center;\n    justify-content: center;\n    grid-template-columns: 1fr;\n}\n\n.DropdownProductFeatures-title {\n    font-size: var(--titleShowcaseStoresTitleSize);\n    color: var(--titleShowcaseStoresTitleColor);\n    font-weight: bold;\n    font-family: var(--font-family);\n}\n\n.DropdownProductFeatures .ant-collapse-header,\n.DropdownProductFeatures .ant-collapse-content{\n    position: relative;\n}\n\n.DropdownProductFeatures > .ant-collapse > .ant-collapse-item:not(:last-child) .ant-collapse-header:after,\n.DropdownProductFeatures > .ant-collapse > .ant-collapse-item:not(:last-child) .ant-collapse-content:after,\n.DropdownProductFeatures > .ant-collapse > .ant-collapse-item:last-child .ant-collapse-content:before {\n    content: '';\n    display: block;\n    width: calc(100% - 64px);\n    height: 2px;\n    background: #DCE2F0;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: 0 auto;\n}\n\n.DropdownProductFeatures > .ant-collapse:last-child .ant-collapse-content:before {\n    bottom: initial;\n    top: 0;\n}\n\n.DropdownProductFeatures .CollapseIconCustom-arrow {\n    font-size: calc(var(--storeNameSize) + 6px)  !important;\n    line-height: calc(var(--storeNameSize) + 12px) !important;\n    position: absolute;\n    right: 32px;\n    top: 0;\n    bottom: 0;\n    margin: auto 0;\n    color: var(--titleShowcaseStoresLinkColor) !important;\n    transition: ease 200ms all;\n}\n\n.DropdownProductFeatures .CollapseIconCustom-arrow.active {\n    transform: rotateZ(-180deg);\n}\n\n.DropdownProductFeatures .DropdownProductFeatures-title {\n    display: block;\n    padding: 16px 0;\n    font-family: var(--font-family);\n    color: var(--storeNameColor);\n    font-weight: bold;\n    font-size: var(--storeNameSize);\n    line-height: calc(var(--storeNameSize) + 6px);\n}\n\n\n.DropdownProductFeatures .ant-collapse-content {\n    padding: 18px 32px 24px;\n}\n\n.DropdownProductFeatures > .ant-collapse:last-child .ant-collapse-content {\n    margin-bottom: 24px;\n}\n\n.DropdownProductFeatures .ant-collapse-content .ant-collapse-content-box {\n    padding: 0;\n}\n\n.DropdownProductFeatures .ant-collapse-content,\n.DropdownProductFeatures .ant-collapse-header{\n    background-color: #ffffff !important;\n}\n\n\n.DropdownProductFeatures-text {\n    font-family: var(--font-family);\n    font-size: var(--storeNameSize);\n    line-height: calc(var(--storeNameSize) + 6px);\n    word-spacing: 2px;\n}\n\n.DropdownProductFeatures-text strong,\n.DropdownProductFeatures-text b {\n    font-weight: bold;\n    display: inline;\n    padding-right: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
